var module = angular.module('octopusApp.infrastructure');

module.controller('SortDialogController', function ($scope, busy, options, $uibModalInstance) {
  var isLoading = $scope.isLoading = busy.create();
  var isSaving = $scope.isSaving = busy.create();
  $scope.options = options;
  $scope.items = [];

  if ($scope.options.load) {
    $scope.options.load({
      busy: isLoading,
      render: function (items) {
        $scope.items = items;
      }
    });
  }

  $scope.close = function() {
    $uibModalInstance.close();
  };

  $scope.save = function () {
    $scope.options.save(_.map($scope.items, function(item) { return item.id; }), {
      busy: isSaving,
      dismiss: function () {
        $uibModalInstance.close();
      }
    });
  };
});



//////////////////
// WEBPACK FOOTER
// ./app/infrastructure/controllers/sort_dialog_controller.js
// module id = 650
// module chunks = 1